import { ConversationSummary, LinkedTo, MessageView } from '../core/hub-types';

/** One "Unlink from …" action on a message: the store's unlink takes `messageId` and the patient chat's id. */
export interface UnlinkTarget {
  messageId: string;
  conversationId: string;
  /** the patient as the question names them */
  patient: string;
  label: string;
}

/**
 * The unlink actions on a message filed to the wrong patient: one per patient chat it is filed to (`links`, the ones
 * this viewer sees), and on its copy in a patient chat, one for that patient. A deleted copy has been unlinked already.
 */
export function unlinkTargets(
  m: Pick<MessageView, 'id' | 'kind' | 'deletedAt'> & { pending?: boolean },
  links: Pick<LinkedTo, 'conversationId' | 'name'>[],
  conversation: Pick<ConversationSummary, 'id' | 'type'>,
  conversationTitle: string,
): UnlinkTarget[] {
  if (m.deletedAt || m.pending) return [];
  const out: UnlinkTarget[] = [];
  if (m.kind === 'linked_copy' && conversation.type === 'patient') {
    out.push({ messageId: m.id, conversationId: conversation.id, patient: conversationTitle || 'this patient', label: 'Unlink from this patient' });
  }
  for (const l of links) {
    const patient = l.name || 'this patient';
    out.push({ messageId: m.id, conversationId: l.conversationId, patient, label: `Unlink from ${patient}` });
  }
  return out;
}
